import { msg } from '@lingui/core/macro'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { ProjectPortalTab } from '~/components/portal/project-portal-tab'
import { useProjectDetail } from '~/components/projects/project-detail'
import { titleFor } from '~/lib/route-title'

const ProjectPortalRoute = () => {
  const project = useProjectDetail()

  if (project.wonAt === undefined) {
    return <Navigate from={Route.fullPath} replace to=".." />
  }
  return (
    <div className="px-5 pb-6">
      <ProjectPortalTab project={project} />
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects/$projectId/portal')({
  component: ProjectPortalRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Portal`) }] }),
})
